import React from 'react'
import { Box } from '@node-space/ui-components'
import { CardDetails } from './CardDetails'
import { CardTransactionsTable } from './CardTransactionsTable'

export const CustomerCard = () => {
  return (
    <Box flexCol gapY={24} width="full">
      <CardDetails />
      <CardTransactionsTable />
    </Box>
  )
}
